//------------------------------------------------------------------------------
// name: BankSelector.tsx
// author: mudas
// created: 2025/12/09
//------------------------------------------------------------------------------

import React, { FC } from 'react';
import { useSafeQuery } from 'common/hooks';
import { useProxyValue } from 'common/components';
import { selectFilterOption } from 'common/helper/search';

import { Identity } from 'common/types';
import service from 'common/service';

import { Select, SelectProps } from '@fuxi/eevee-ui';

type ValueType = string | string[];
type OptionType = Identity;
export interface IProps extends SelectProps<ValueType, OptionType> {
  // 是否返回 option 替代 value
  replaceAsOption?: boolean;
}

const BankSelector: FC<IProps> = (props) => {
  const { replaceAsOption, value: baseValue, onChange: baseOnChange, ...otherProps } = props;

  const { value, onChange } = useProxyValue({
    fieldName: 'bankId',
    replaceAsOption,
    value: baseValue,
    onChange: baseOnChange,
  });

  const { data, isFetching } = useSafeQuery({
    queryKey: ['getBankList'],
    queryFn: async () => {
      const res = await service.userSetting.getBankList();
      return res.data;
    },
    cacheTime: 10 * 60 * 1000,
    staleTime: 10 * 60 * 1000,
    fetchingDelay: 200,
  });

  return (
    <Select<ValueType, OptionType>
      loading={isFetching}
      options={data?.items}
      value={value}
      showSearch
      allowClear
      placeholder="请选择银行"
      fieldNames={{ label: 'bankName', value: 'bankId' }}
      filterOption={selectFilterOption({ label: 'bankName', value: 'bankId' })}
      onChange={onChange}
      {...otherProps}
    />
  );
};

export default BankSelector;
